import { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  Stack
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import logo1 from "../../assets/images/Vector.svg"
import logo2 from "../../assets/images/Vector1.svg"
import logo3 from "../../assets/images/Vector2.svg"
import logo4 from "../../assets/images/Group 579.svg"
import uparrow from "../../assets/arrowicons/Group 26.svg"
import Downarrow from "../../assets/arrowicons/Group 28.svg"

import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";



export default function KpiMetricscards({ cardsData = [], kpiBriefData = [] }) {
  // const [openDetails, setOpenDetails] = useState(false);
  const [openCardIndex, setOpenCardIndex] = useState(null);

  const handleToggleDetails = (index) => {
    setOpenCardIndex(prev => prev === index ? null : index);
  };

  const [showGoal, setShowGoal] = useState(false);
  const [selectedKpiBrief, setSelectedKpiBrief] = useState(null);

  useEffect(() => {
    if (!selectedKpiBrief && kpiBriefData.length > 0) {
      setSelectedKpiBrief(kpiBriefData[0]);
    }
  }, [kpiBriefData, selectedKpiBrief]);
  // console.log(selectedKpiBrief, "****")
  const navigate = useNavigate();

  const color = "#0e5ba0";
  const location = useLocation();
  const handleOpenReport = (title) => {
    if (title === "Net Sales") {
      window.open(
        "https://app.fabric.microsoft.com/groups/430a39ed-cee2-4e8f-a7d9-3656dd3e9c18/reports/9c8a8269-8419-4ce3-9039-2de4e055ee73/d60bec7ea6a63e394c46?experience=fabric-developer", "_blank",
      );
    }
  };
  

  return (
    <Grid container rowSpacing={2}
      columnSpacing={{ xs: 1, sm: 1.5, md: 2 }}
      sx={{ mt: 0 }}>
      {cardsData.map((card, i) => (
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={i} sx={{ paddingTop: "26px !important" }}>
          <Card
            sx={{
              borderRadius: "4px",
              background: "#fff",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.08)",
              overflow: "visible",
              position: "relative",
              paddingTop: "28px",
              minWidth: 0  // Allow card to shrink
            }}
          // className="custom-card"
          >
            {/* HEADER LABEL */}
            <Box
              sx={{
                position: "absolute",
                top: "-10px",
                left: { xs: "8px", sm: "12px", md: "16px" },
                right: { xs: "8px", sm: "12px", md: "16px" },
                height: "36px",
                background: "#115f9c",
                borderRadius: "4px !important",
                display: "flex",
                alignItems: "center",
                p: { xs: "0px 8px", sm: "0px 10px", md: "0px 12px" },
                boxShadow: "0px 4px 12px rgba(13,110,253,0.35)"
              }}
            >
              {/*  TITLE + STATUS DOT */}
              <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0, overflow: "hidden" }}>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "11px", sm: "12px", md: "16px" },
                    fontWeight: 200,
                    mr: "6px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {card.title}
                </Typography>

                <Tooltip
                  title="Calculated from the latest fully closed period; no open-period data included."
                  placement="right"
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#1f1f1f",
                        color: "#fff",
                        fontSize: "12px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        maxWidth: "260px",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#1f1f1f",
                      },
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: card.showIndicator ? 8 : 0,
                      height: card.showIndicator ? 8 : 0,
                      borderRadius: "50%",
                      cursor: "pointer",
                      backgroundColor:
                        card.values.some(v => v.status === "decrease")
                          ? "#d9534f"
                          : card.values.some(v => v.status === "increase")
                            ? "#11C634"
                            : "#cccccc",
                    }}
                  />
                </Tooltip>

              </Box>

              {/* TOGGLE BUTTON */}
              <Box
                onClick={() => handleToggleDetails(i)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  color: "#ffffff",
                  fontSize: "10px",
                  fontWeight: 300,
                  gap: "4px",
                  userSelect: "none"
                }}
              >
                <KeyboardArrowDownIcon
                  sx={{
                    fontSize: "18px",
                    color: "#ffffff",
                    transition: "0.3s",
                    transform: openCardIndex === i ? "rotate(180deg)" : "rotate(0deg)"

                  }}
                />
                {openCardIndex === i ? "BRIEF" : "DETAILS"}
              </Box>
            </Box>

            <CardContent sx={{ mt: 0, overflowX: "auto", paddingTop: openCardIndex === i ? "8px" : "" }}>
              {openCardIndex !== i ? (
                /* DETAILS VIEW */
                <Box sx={{ display: "flex", justifyContent: "space-between", minWidth: "fit-content", gap: { xs: '22px', sm: '22px', md: '0px' },width:"90%" }}>
                  {card.values.map((v, idx) => (
                    <Box key={idx} sx={{ textAlign: "left" }}>
                      {/* LABEL + ARROW + CHANGE */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between"
                        }}>
                        <Box
                          sx={{
                            position: "relative",
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              left: "0",
                              right: "0",
                              width: "10px",
                              height: "50px",
                              borderLeft: "0.5px solid #404040",
                              borderBottom: "0.5px solid #404040",
                              borderBottomLeftRadius: "10px"
                            }
                          }}
                        >
                          <Chip
                            label={v.label}
                            size="small"
                            sx={{
                              background:
                                v.status === "increase"
                                  ? " #3087C5"
                                  : v.status === "decrease"
                                    ? "#FF565C"
                                    : " #3087C5",
                              color: "#fff",
                              fontSize: "8px",
                              fontWeight: 300,
                              borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              height: "20px",
                              mr: "2px",
                              '& .MuiChip-label': {
                                padding: '0px 6px',
                              },
                            }}
                          />
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            fontSize: "15px",
                            fontWeight: 300,
                            color:
                              v.status === "increase"
                                ? "#107D25"
                                : v.status === "decrease"
                                  ? "#FF565C"
                                  : "#107D25"
                          }}
                        >
                          {v.status === "increase" ? (
                            <img src={uparrow} alt="" width={16} height={18} />
                          ) : v.status === "decrease" ? (
                            <img src={Downarrow} alt="" width={16} height={18} />
                          ) : (
                            <img src={uparrow} alt="" width={16} height={18} />
                          )}
                          {v.change}
                        </Box>
                      </Box>

                      <Typography
                        sx={{
                          fontSize: "15px",
                          fontWeight: "300",
                          color: "#111111 ",
                          paddingLeft: "16px"
                        }}
                      >
                        {v.value}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                /* BRIEF VIEW */
                <Box>
                  <Box
                    sx={{
                      mb: 1,
                      textAlign: "left",
                      display: "flex",
                      gap: 1,

                    }}
                  >
                    {kpiBriefData.map((kpibrief, index) => {
                      const pctColor =
                        kpibrief.status === "increase"
                          ? "#107D25"
                          : kpibrief.status === "decrease"
                            ? "#FF565C"
                            : "#666";

                      const bottomGradient =
                        kpibrief.status === "increase"
                          ? "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(220,250,236,1) 40%)"
                          : "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,235,238,1) 40%)";

                      return (
                        <Box
                          key={index}
                          onClick={() => setSelectedKpiBrief(kpibrief)}
                          sx={{
                            width: 600,
                            borderRadius: "4px",
                            overflow: "hidden",
                            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                            display: "flex",
                            flexDirection: "column",
                            fontFamily: "Inter",
                            borderBottom: kpibrief.positive ? "3px solid #107D25" : "3px solid #FF565C"
                          }}
                        >
                          {/* top row */}
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              p: "8px 6px 0px 6px"
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "12px",
                                color: "#111111",
                                fontWeight: 300
                              }}
                            >
                              {kpibrief.title}
                            </Typography>

                            <Stack
                              direction="row"
                              spacing={0.4}
                              alignItems="center"
                              sx={{
                                ml: 1,
                                fontSize: "10px",
                                fontWeight: 200,
                                color: pctColor
                              }}
                            >
                              {kpibrief.status === "increase" ? (
                                <NorthIcon sx={{ fontSize: "12px !important" }} />
                              ) : (
                                <SouthIcon sx={{ fontSize: "12px !important" }} />
                              )}
                              <Typography
                                sx={{ fontSize: "12px", color: pctColor }}
                              >
                                {kpibrief.pct}
                              </Typography>
                            </Stack>
                          </Box>

                          {/* value + LY */}
                          <Box
                            sx={{
                              p: "12px 10px 8px 0px",
                              background: bottomGradient
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: "24px",
                                fontWeight: '200',
                                lineHeight: 1,
                                textAlign: "center"
                              }}
                            >
                              {kpibrief.value}
                            </Typography>

                            <Box
                              sx={{
                                display: "flex",
                                // alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1,
                                mt: "14px"
                              }}
                            >
                              <Chip
                                label={showGoal ? "GOAL" : "LY"}
                                size="small"
                                sx={{
                                  bgcolor: kpibrief.positive ? "#107D25" : "#FF565C",
                                  color: "#fff",
                                  height: "18px",
                                  fontWeight: 400,
                                  fontSize: 10,
                                  // width: 50,
                                  borderBottomLeftRadius: 0,
                                  borderTopLeftRadius: 0,
                                  borderBottomRightRadius: "6px",
                                  borderTopRightRadius: "6px"
                                }}
                              />

                              <Typography
                                sx={{
                                  fontSize: "12px !important",
                                  color: "#111111",
                                  fontWeight: 200
                                }}
                              >
                                {showGoal ? kpibrief.glvalue : kpibrief.lyValue}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      );
                    })}
                  </Box>

                  {/* QUICK ACTIONS */}
                  <Box
                    sx={{
                      mt: "20px",
                      textAlign: "left",
                      display: "flex",
                      gap: 1
                    }}
                  >
                    <Box
                      sx={{
                        width: 500,
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                        pl: 1
                      }}
                    >

                      {/* SHOW GOAL */}
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        onClick={() => setShowGoal(prev => !prev)}
                        sx={{ cursor: "pointer" }}
                      >
                        <img src={logo4} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          {showGoal ? "SHOW LY" : "SHOW GOAL"}
                        </Typography>
                      </Stack>

                      {/* ASK AGENT */}
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        onClick={() => {
                          const predefinedMessage = "Create a Line Chart for monthly Sales vs Goal for the Past 12 months";
                          navigate("/intelligence", {
                            state: selectedKpiBrief?.Kpinames === "Net Sales"
                              ? { kpi: selectedKpiBrief, message: predefinedMessage }
                              : { message: predefinedMessage },
                          });
                        }}
                        sx={{ cursor: "pointer" }}
                      >
                        <img src={logo1} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          ASK AGENT (BETA)
                        </Typography>
                      </Stack>

                      {/* OPEN CUBE */}
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        onClick={() => handleOpenReport(card.title)}
                        sx={{ cursor: "pointer" }}
                      >
                        <img src={logo3} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          OPEN CUBE
                        </Typography>
                      </Stack>

                      {/* MSG ANALYST */}
                      <Stack direction="row" spacing={1} alignItems="center">
                        <img src={logo2} alt="" width={16} height={16} />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 400,
                            color: "#115F9C"
                          }}
                        >
                          MSG ANALYST (BETA)
                        </Typography>
                      </Stack>

                    </Box>
                  </Box>

                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
